export const INBOX_PRIMARY_ROW_CLASS = "h-16 border-b";
